export const getFontSize = (text?: string) => {
  if (text && text?.length > 10) {
    return 24
  }

  return 30
}
